import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Typography } from '@mui/material';
import { MRT_ColumnDef } from 'material-react-table';
import dayjs from 'dayjs';

import { useFetchGestionTickets } from '@/shared/actions/erp/tickets-soporte-cliente/gestion-tickets.actions';
import { ITicket } from '@/shared/interfaces/erp/tickets-soporte-clientes';
import { GeneralTable } from '@/shared/components/ui';

type TabHistorialTicketsProps = {
  clienteId: number;
};

export default function TabHistorialTickets({ clienteId }: TabHistorialTicketsProps) {
  const navigate = useNavigate();

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const { data: ticketsData, isLoading, isRefetching } = useFetchGestionTickets({
    page: pagination.pageIndex + 1,
    page_size: pagination.pageSize,
    cliente_id: clienteId as any,
    enabled: !!clienteId,
  });

  const tickets = (ticketsData as any)?.data?.data ?? [];
  const totalRows = (ticketsData as any)?.data?.count ?? 0;

  const columns = useMemo<MRT_ColumnDef<ITicket>[]>(
    () => [
      {
        accessorKey: 'codigo_ticket',
        header: 'Codigo',
      },
      {
        accessorKey: 'tipo',
        header: 'Tipo',
        Cell: ({ row }) => row.original.tipo_data?.nombre ?? row.original.tipo,
      },
      {
        accessorKey: 'estado_ticket',
        header: 'Estado',
        Cell: ({ row }) => row.original.estado_ticket_data?.nombre ?? row.original.estado_ticket,
      },
      {
        accessorKey: 'prioridad',
        header: 'Prioridad',
        Cell: ({ row }) => row.original.prioridad_data?.nombre ?? row.original.prioridad,
      },
      {
        accessorKey: 'fecha_creacion',
        header: 'Fecha Creacion',
        Cell: ({ row }) => dayjs(row.original.fecha_creacion).format('DD/MM/YYYY HH:mm'),
      },
      {
        accessorKey: 'usuario_asignado_nombre',
        header: 'Asignado a',
        Cell: ({ row }) => row.original.usuario_asignado_nombre || 'Sin asignar',
      },
    ],
    []
  );

  const handleEdit = (ticket: ITicket) => {
    navigate(`/tickets-soporte-cliente/detalle-ticket/${ticket.id_ticket}`);
  };

  return (
    <Grid item xs={12}>
      {!clienteId ? (
        <Typography variant="body2" color="text.secondary" textAlign="center">
          No se pudo obtener el ID del cliente.
        </Typography>
      ) : (
        <GeneralTable<ITicket>
          columns={columns}
          data={tickets}
          isLoading={isLoading}
          isRefetching={isRefetching}
          pagination={pagination}
          onPaging={setPagination}
          rowCount={totalRows}
          canEdit
          onEdit={handleEdit}
          toolTipTitleEditIcon="Ver Detalle"
          enableColumnActions={true}
          density="compact"
        />
      )}
    </Grid>
  );
}
